// GERADO por `make module-ids` a partir de backend/app/config/modules.yml — NÃO editar à mão.
// Acrescentar um módulo ou uma feature faz-se no catálogo; este ficheiro regenera-se.

export const CORE_MODULES = [
  "dashboard",
  "platform",
  "sistema",
] as const;

export const OPTIONAL_MODULES = [
  "artigos",
  "comercial",
  "comercial_avancado",
  "energia",
  "financeiro",
  "hr",
  "ordens_fabrico",
  "producao",
  "rececao",
  "reciclados",
  "security",
  "terceiros",
] as const;

export const FEATURES = [
  "artigos.catalogo_base",
  "artigos.ficha_malha",
  "artigos.tabela_medidas",
  "comercial.alteracoes",
  "comercial.email_triage",
  "comercial.importar_po",
  "comercial.leads",
  "comercial.painel_encomendas",
  "comercial.proposta_caixas",
  "hr.recrutamento_publico",
  "hr.time_bank",
  "ordens_fabrico.lotes",
  "ordens_fabrico.planeamento",
  "ordens_fabrico.qualidade",
  "ordens_fabrico.rotulos",
  "ordens_fabrico.subcontratacao",
  "platform.feed",
  "producao.aprovisionamento",
  "producao.avaliacao_fornecedores",
  "producao.manutencao",
  "rececao.api_parcelparcel",
  "rececao.pedidos_material",
  "reciclados.dyeing",
  "reciclados.legacy_import",
  "terceiros.equivalencia_cores",
  "terceiros.portal_certificados",
  "terceiros.portal_certificados_cron_automatico",
] as const;

export type ModuleId = (typeof CORE_MODULES)[number] | (typeof OPTIONAL_MODULES)[number];

/** `<módulo>.<funcionalidade>`; um erro de escrita deixa de compilar em vez de desligar a funcionalidade em silêncio. */
export type FeatureId = (typeof FEATURES)[number];
